// extracted by mini-css-extract-plugin
module.exports = {"form":"CreateDeckPage_form__2scZO","formControl":"CreateDeckPage_formControl__1ZM95","buttons":"CreateDeckPage_buttons__12wcy"};